<div id="principal" class="container-fluid">
  <div class="card text-left">
    <div class="d-flex flex-row topo justify-content-between">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item aba-cabecalho">
            <a
              class="nav-link"
              [class.active]="aba === AbaEnum.Agenda"
              id="nav-home-tab"
              data-toggle="tab"
              (click)="selecionarAba(AbaEnum.Agenda)"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Agenda</a
            >
          </li>
          <li class="nav-item aba-cabecalho">
            <a
              class="nav-link"
              [class.active]="aba === AbaEnum.DadosAtendimento"
              id="nav-home-tab"
              data-toggle="tab"
              (click)="selecionarAba(AbaEnum.DadosAtendimento)"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Dados do Atendimento</a
            >
          </li>
          <li class="nav-item aba-cabecalho">
            <a
              class="nav-link"
              [class.active]="aba === AbaEnum.Evolucao"
              id="nav-home-tab"
              data-toggle="tab"
              (click)="selecionarAba(AbaEnum.Evolucao)"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Evolução</a
            >
          </li>
          <li class="nav-item aba-cabecalho">
            <a
              class="nav-link"
              [class.active]="aba === AbaEnum.Prescricao"
              id="nav-home-tab"
              data-toggle="tab"
              (click)="selecionarAba(AbaEnum.Prescricao)"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Prescrição</a
            >
          </li>
          <li class="nav-item aba-cabecalho">
            <a
              class="nav-link"
              [class.active]="aba === AbaEnum.PedidosExames"
              id="nav-home-tab"
              data-toggle="tab"
              (click)="selecionarAba(AbaEnum.PedidosExames)"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Pedidos de Exames</a
            >
          </li>
          <li class="nav-item aba-cabecalho">
            <a
              class="nav-link"
              [class.active]="aba === AbaEnum.Encaminhamento"
              id="nav-home-tab"
              data-toggle="tab"
              (click)="selecionarAba(AbaEnum.Encaminhamento)"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Encaminhamento</a
            >
          </li>
          <li class="nav-item aba-cabecalho">
            <a
              class="nav-link"
              [class.active]="aba === AbaEnum.Atestados"
              id="nav-home-tab"
              data-toggle="tab"
              (click)="selecionarAba(AbaEnum.Atestados)"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Atestados</a
            >
          </li>
          <li class="nav-item aba-cabecalho">
            <a
              class="nav-link"
              [class.active]="aba === AbaEnum.ProntuariosAvulsos"
              id="nav-home-tab"
              data-toggle="tab"
              (click)="selecionarAba(AbaEnum.ProntuariosAvulsos)"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              >Prontuários Avulsos</a
            >
          </li>
          <!-- <li class="nav-item aba-cabecalho">
            <a class="nav-link" [class.active]="aba === AbaEnum.Chat" id="nav-home-tab" data-toggle="tab"
                  (click)="selecionarAba(AbaEnum.Chat)" role="tab" aria-controls="nav-home" aria-selected="true">CHAT</a>
          </li> -->
        </ul>
      </div>
      <div class="saida">

        <span class="badge bg-light text-secondary border me-3 mr-3">
          Versão: {{ versaoApp }}
        </span>
        
        <button
          *ngIf="emAtendimento"
          class="btn btn-primary me-2 mr-2"
          (click)="salvarAtendimento()"
        >
          Salvar Atendimento
        </button>
        <button
          *ngIf="emAtendimento"
          class="btn btn-primary mr-2 me-2"
          (click)="finalizarAtendimento()"
        >
          Finalizar Atendimento
        </button>
        <button
          class="btn btn-outline-primary me-2"
          (click)="abrirModalAlterarSenha()"
        >
          <i class="bi bi-key-fill"></i> Alterar Senha
        </button>
        <button class="btn btn-primary" (click)="logoff()">Sair</button>
      </div>

      <div
        class="modal fade"
        [ngClass]="{ 'show d-block': mostrarModalSenha }"
        tabindex="-1"
        role="dialog"
        *ngIf="mostrarModalSenha"
        style="background: rgba(0, 0, 0, 0.5)"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title">
                <i class="bi bi-shield-lock"></i> Alterar Senha de Acesso
              </h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                (click)="fecharModalAlterarSenha()"
              ></button>
            </div>

            <div class="modal-body">
              <form [formGroup]="formSenha" (ngSubmit)="salvarNovaSenha()">
                <div class="mb-3">
                  <label class="form-label fw-bold">Senha Atual</label>
                  <div class="input-group has-validation">
                    <input
                      [type]="verSenhaAtual ? 'text' : 'password'"
                      class="form-control"
                      formControlName="currentPassword"
                      placeholder="Digite a senha atual"
                      [ngClass]="{
                        'is-invalid': submetido && f['currentPassword'].errors,
                      }"
                    />
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      (click)="verSenhaAtual = !verSenhaAtual"
                    >
                      <i
                        class="bi"
                        [ngClass]="verSenhaAtual ? 'bi-eye-slash' : 'bi-eye'"
                      ></i>
                    </button>
                    <div class="invalid-feedback">
                      A senha atual é obrigatória.
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label fw-bold">Nova Senha</label>
                  <div class="input-group has-validation">
                    <input
                     [type]="verNovaSenha ? 'text' : 'password'"
                      class="form-control"
                      formControlName="newPassword"
                      placeholder="Ex: SenhaForte@123"
                      [ngClass]="{
                        'is-invalid': submetido && f['newPassword'].errors,
                      }"
                    />

                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      (click)="verNovaSenha = !verNovaSenha"
                    >
                      <i
                        class="bi"
                        [ngClass]="verNovaSenha ? 'bi-eye-slash' : 'bi-eye'"
                      ></i>
                    </button>
                    <div class="invalid-feedback">
                      <span *ngIf="f['newPassword'].errors?.['required']"
                        >A nova senha é obrigatória.</span
                      >
                      <span *ngIf="f['newPassword'].errors?.['minlength']"
                        >Mínimo de 6 caracteres.</span
                      >
                      <span *ngIf="f['newPassword'].errors?.['pattern']">
                        A senha deve conter: <br />
                        • Letra Maiúscula <br />
                        • Letra Minúscula <br />
                        • Número <br />
                        • Caractere Especial (@#$...)
                      </span>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
  <label class="form-label fw-bold">Confirmar Nova Senha</label>
  
  <div class="input-group has-validation">
    
    <input [type]="verConfirmacao ? 'text' : 'password'" 
           class="form-control" 
           formControlName="passwordConfirmation"
           placeholder="Repita a nova senha"
           
           [ngClass]="{
             'is-invalid': submetido && (f['passwordConfirmation'].errors || formSenha.hasError('notSame'))
           }">
           <button class="btn btn-outline-secondary" type="button" (click)="verConfirmacao = !verConfirmacao">
      <i class="bi" [ngClass]="verConfirmacao ? 'bi-eye-slash' : 'bi-eye'"></i>
    </button>

    <div class="invalid-feedback">
      <span *ngIf="f['passwordConfirmation'].errors?.['required']">
        Confirmação obrigatória.
      </span>
      
      <span *ngIf="formSenha.hasError('notSame')">
        As senhas não conferem.
      </span>
    </div>

  </div>
</div>

                <div class="alert alert-danger" *ngIf="msgErro">
                  {{ msgErro }}
                </div>
                <div class="alert alert-success" *ngIf="msgSucesso">
                  {{ msgSucesso }}
                </div>

                <div class="modal-footer p-0 pt-3 border-0">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="fecharModalAlterarSenha()"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="loading"
                  >
                    <span
                      *ngIf="loading"
                      class="spinner-border spinner-border-sm me-2"
                    ></span>
                    {{ loading ? "Salvando..." : "Confirmar Alteração" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="superior" class="card-body">
      <div class="row">
        <div class="col-md-12" [hidden]="aba == 0">
          <app-cabecalho [hidden]="aba == 7"></app-cabecalho>
          <app-prontuarios-avulsos
            [hidden]="aba != 7"
          ></app-prontuarios-avulsos>
        </div>
      </div>
    </div>

  <div id="inferior" class="card-body">
      <div class="row">
        <div id="agenda" class="col-md-12" [hidden]="aba != 0">
          <app-agenda></app-agenda>
        </div>

        <div id="consulta" class="col-md-3" [hidden]="aba < 1 || aba == 7 || aba == 8">
          <app-tabela-consulta></app-tabela-consulta>
        </div>

        <div class="col-md-9 etapas" [hidden]="aba != 1">
          <app-procedimentos></app-procedimentos>
        </div>

        <div class="col-md-9 etapas" [hidden]="aba != 2">
          <app-evolucao></app-evolucao>
        </div>

        <div class="col-md-9 etapas" [hidden]="aba != 3">
          <app-prescricao></app-prescricao>
        </div>

        <div class="col-md-9 etapas" [hidden]="aba != 4">
          <app-exames></app-exames>
        </div>

        <div class="col-md-9 etapas" [hidden]="aba != 5">
          <app-encaminhamento></app-encaminhamento>
        </div>

        <div class="col-md-9 etapas" [hidden]="aba != 6">
          <app-atestados></app-atestados>
        </div>

        <div class="col-md-9 etapas" [hidden]="true"> <app-prescricao></app-prescricao>
        </div>

        <div class="col-md-9 etapas" [hidden]="aba != 8">
          <app-chat></app-chat>
        </div>
      </div>
    </div>
